import { Observable, Subject, Subscriber } from 'rxjs';
import { debounceTime, switchMapTo } from 'rxjs/operators';

export class SyncQueue extends Observable<void> {
    private delay: number;
    private observer: Subscriber<void>;
    private queue$ = new Subject<void>();

    constructor(delay = 20) {
        super(o => {
            this.observer = o;
        });

        this.delay = delay;
    }

    get started() {
        return this.queue$.observers.length > 0;
    }

    public start() {
        return this.queue$.pipe(debounceTime(this.delay)).subscribe(() => this.observer.next());
    }

    public tick() {
        this.queue$.next();
    }
}
